import { CustomData } from 'owa-analytics-actions';
import { logUsage } from 'owa-analytics';

export enum A2HSMetric {
    // Common Metrics
    PWA_INSTALLED = 'A2HS_PWAInstalled',
    INSTALL_ACCEPTED = 'A2HS_InstallAccepted',
    INSTALLED = 'A2HS_Installed',

    // Custom Banner Metrics
    USER_ELIGIBLE = 'A2HS_UserEligible',
    CUSTOM_BANNER_IMPRESSION = 'A2HS_CustomBannerImpression',
    CUSTOM_BANNER_CLICKED = 'A2HS_CustomBannerClicked',
    CUSTOM_BANNER_DISMISSED = 'A2HS_CustomBannerDismissed',

    // Persistent Banner Metrics
    PERSISTENT_BANNER_IMPRESSION = 'A2HS_PBImpression',
    PERSISTENT_BANNER_CLICKED = 'A2HS_PBClicked',

    // Teaching Pane Metrics
    TEACHING_PANE_IMPRESSION = 'A2HS_TPImpression',
    TEACHING_PANE_DISMISSED = 'A2HS_TPDismissed',

    // Tooltip Metrics
    TOOLTIP_IMPRESSION = 'A2HS_TooltipImpression',
}

export const logMetric = (metricName: A2HSMetric, customData?: CustomData) => {
    logUsage(metricName, customData, { isCore: true });
};
